import axios from 'axios';
import { API_URL } from '../config';

export const getEvents = ({ events }) => events;
const reducerName = 'calendarEvents';
const createActionName = (name) => `app/${reducerName}/${name}`;

const LOAD_EVENTS = createActionName('LOAD_EVENTS');
const ADD_EVENT = createActionName('ADD_EVENT');
const EDIT_EVENT = createActionName('EDIT_EVENT');
const DELETE_EVENT = createActionName('DELETE_EVENT');

export const loadEvents = (payload) => ({ payload, type: LOAD_EVENTS });
export const addEvent = (payload) => ({ payload, type: ADD_EVENT });
export const editEvent = (payload) => ({ payload, type: EDIT_EVENT });
export const deleteEvent = (payload) => ({ payload, type: DELETE_EVENT });

export const loadEventsRequest = () => {
  return async (dispatch) => {
    try {
      let res = await axios.get(`${API_URL}/calendar-event`, {
        withCredentials: true,
      });

      dispatch(loadEvents(res.data));
      return res;
    } catch (e) {
      console.log(e.message);
    }
  };
};

export const addEventRequest = (data) => {
  return async (dispatch) => {
    try {
      let res = await axios.post(`${API_URL}/calendar-event`, data, {
        withCredentials: true,
      });
      dispatch(addEvent(res.data));
      return res;
    } catch (e) {
      console.log(e.message);
    }
  };
};
export const editEventRequest = (data) => {
  return async (dispatch) => {
    try {
      let res = await axios.put(`${API_URL}/calendar-event/${data.id}`, data, {
        withCredentials: true,
      });
      dispatch(editEvent(res.data));
      return res;
    } catch (e) {
      console.log(e.message);
    }
  };
};

export const deleteEventRequest = (id) => {
  return async (dispatch) => {
    try {
      let res = await axios.delete(`${API_URL}/calendar-event/${id}`, {
        withCredentials: true,
      });
      dispatch(deleteEvent(id));
      return res;
    } catch (e) {
      console.log(e.message);
    }
  };
};

const eventsReducer = (statePart = [], action) => {
  switch (action.type) {
    case LOAD_EVENTS:
      return [...action.payload];
    case ADD_EVENT:
      return [...statePart, action.payload];
    case EDIT_EVENT:
      return statePart.map((event) =>
        event.id === action.payload.id ? { ...action.payload } : event,
      );
    case DELETE_EVENT:
      return [...statePart.filter((el) => el.id !== action.payload)];
    default:
      return statePart;
  }
};

export default eventsReducer;
